import API from "shared/services/Api";
import {
  IRecordPhysical,
  IRecordPhysicalResponse,
} from "shared/types/RecordPhysical";

export const getPhysical = async (
  data: IRecordPhysical
): Promise<IRecordPhysicalResponse> =>
  API.get(`oc/fichafisico?id=${data.userId}&idPac=${data.idPac}`);
